<app-chip [color]="color()" [attr.data-testid]="'lead-stage-chip-' + stage()">
  {{ labelKey() | translate }}
</app-chip>
